import { useEffect, useState } from "react";
import { Table, Space, Tag, Button, Row, Col, Modal, Form, notification, Select, Tooltip, Pagination, Input } from "antd";
import { EyeOutlined, EditOutlined, DeleteOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons";
import ScheduleForm from "./ScheduleForm";
import { bookingService } from "../../../services";
import dayjs from "dayjs";
import { checkPermission } from "../../../utils/permissions";
import { changeDocumentTitle } from "../../../utils/title";

function BookingSchedule() {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [refresh, setRefresh] = useState(true);
  const [isAddModalVisible, setIsAddModalVisible] = useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [editData, setEditData] = useState(null);
  const [pagination, setPagination] = useState({
    current: 1,
    total: 0,
    pageSize: 10,
  });
  const [loading, setLoading] = useState(false);
  const [booking, setBooking] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState();
  const [viewBooking, setViewBooking] = useState([]);
  const options = [
    {
      value: "10",
      label: "10",
    },
    {
      value: "25",
      label: "25",
    },
    {
      value: "50",
      label: "50",
    },
  ];

  const columns = [
    {
      title: "Id",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "Date",
    },
    {
      title: "Start time",
      dataIndex: "start_time",
      key: "Starttime",
      render: (text) => dayjs(text, 'HH:mm:ss').format('hh:mm A')
    },
    {
      title: "End time",
      dataIndex: "end_time",
      key: "Endtime",
      render: (text) => dayjs(text, 'HH:mm:ss').format('hh:mm A')
    },
    {
      title: "Appointment Allowed",
      dataIndex: "allowed_appointments",
      key: "AppointmentAllowed",
      align: "center",
    },
    {
      title: "Appointment Confirm",
      dataIndex: "booked_appointments",
      key: "AppointmentConfirm",
      align: "center",
    },
    {
      title: "Appointment Left",
      dataIndex: "left_appointments",
      key: "AppointmentLeft",
      align: "center",
    },
    {
      title: "Status",
      dataIndex: "isActive",
      key: "Status",
      render: (status) => (
        <Tag
          color={status === 1 ? '#06D652' : '#C93E3E'}
          style={{ padding: "5px", fontSize: '11px' }}
        >
          {status === 1 ? "Active" : "InActive"}
        </Tag>
      ),
    },
    {
      title: "Actions",
      key: "Actions",
      render: (text, record) => (
        <Space size="small">
          <Tooltip title="Edit">
            {/* <Button
              type="primary"
              size="small"
              onClick={() => handleEdit(record)}
            > */}
            <EditOutlined onClick={() => handleEdit(record)} />
            {/* </Button> */}
          </Tooltip>

          <Tooltip title="View">
            {/* <Button
              type="primary"
              size="small"
              onClick={() => { showModal(record.id) }}
            > */}
            <EyeOutlined onClick={() => { showModal(record.id) }} />
            {/* </Button> */}
          </Tooltip>

          {checkPermission("DELETE_BOOKING") && <Tooltip title="Delete">
            {/* <Button
              type="primary"
              size="small"
              onClick={() => visibleModal(record.id)}
            > */}
            <DeleteOutlined onClick={() => visibleModal(record.id)} />
            {/* </Button> */}
          </Tooltip>}
        </Space>
      ),
    },
  ];

  const handleEdit = (record) => {
    setEditData(record);
    setModalVisible(true);
  };

  const handleScheduleCancel = () => {
    setIsAddModalVisible(false);
  };
  const handleModalClose = () => {
    setModalVisible(false);
  };
  const showModal = (record) => {
    setIsModalOpen(true);
    getbooking(record);
  };
  const visibleModal = (record) => {
    setSelectedRecord(record);
    setIsModalVisible(true);
  };

  const handleOk = async () => {
    setLoading(true);
    const response = await bookingService.deletebooking(selectedRecord);
    if (response.success) {
      notification.success({
        message: "Success",
        description: "Booking deleted successfully!",
        placement: "topRight",
      });
      setBooking((prevData) =>
        prevData.filter((item) => item.id !== selectedRecord)
      );
    } else {
      const errors = response.data?.errors || [response.message];
      notification.error({
        message: "Error",
        description: `Error: ${errors.join(", ")}`,
        placement: "topRight",
      });
    }
    initialize(pagination.current, pagination.pageSize);
    setLoading(false);
    setIsModalOpen(false);
    setIsModalVisible(false);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    setIsModalVisible(false);
  };


  const initialize = async (page = 1, pageSize = pagination.current) => {
    setLoading(true);
    const { success, data } = await bookingService.fetch(page, pageSize,);
    setLoading(false);
    if (success) {
      setBooking(data.data);
      setPagination((prev) => ({
        ...prev,
        total: data.total,
        current: page,
        pageSize,
      }));
    }
  };

  const getbooking = async (record) => {
    const response = await bookingService.viewbooking(record);
    if (response.success) {
      setViewBooking(response.data);
    }
  };

  useEffect(() => {
    changeDocumentTitle("Schedule Bookings");
    if (refresh) {
      initialize(pagination.current, pagination.pageSize,);
    }
    setRefresh(false);
  }, [refresh]);

  return (
    <div
      style={{
        padding: "5px",
        border: "1px solid #ccc",
        borderRadius: "8px",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Row gutter={16} align="middle">
        <Col span={12}>
          <h1 style={{ fontWeight: "bold" }} className="pl-2 pt-3">
            Schedule Booking
          </h1>
        </Col>
        {checkPermission("ADD_BOOKING") && <Col span={12} style={{ textAlign: "right" }}>
          <Button
            type="primary"
            icon={<PlusOutlined />}
            onClick={() => setIsAddModalVisible(true)}
          >
            Add Booking
          </Button>
        </Col>}
      </Row>


      {/* Edit modal */}
      <ScheduleForm
        visible={modalVisible}
        onClose={handleModalClose}
        editData={editData}
        setRefresh={setRefresh}
      />
      {/* view modal */}
      <Modal
        title={<div style={{ width: "100%" }}>View Booking Schedule</div>}
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        footer={null}
        closable={true}
        width={600}
        style={{ padding: "15px" }}
      >
        <Form layout="vertical" requiredMark={false}>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="Date" name="date">
                {/* Use plain text instead of DatePicker */}
                <div>{viewBooking?.date || "-"}</div>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item label="Start Time" name="start_time">
                {/* Use plain text instead of TimePicker */}
                <div>{viewBooking?.start_time || "-"}</div>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col span={12}>
              <Form.Item label="End Time" name="end_time">
                {/* Use plain text instead of TimePicker */}
                <div>{viewBooking?.end_time || "-"}</div>
              </Form.Item>
            </Col>
            <Col span={12}>
              <Form.Item
                label="Allowed Appointments"
                name="allowed_appointments"
              >
                {/* Use plain text instead of Input */}
                <div>{viewBooking?.allowed_appointments || "0"}</div>
              </Form.Item>
            </Col>
          </Row>
          <Form.Item>
            {/* Use plain text for the checkbox */}
            <div>
              {viewBooking?.isActive
                ? "Appointment Active"
                : "Appointment Inactive"}
            </div>
          </Form.Item>
        </Form>
      </Modal>

      {/* add modal */}
      <ScheduleForm
        visible={isAddModalVisible}
        onClose={handleScheduleCancel}
        setRefresh={setRefresh}
      />

      {/* delete modal */}
      <Modal
        title={<div style={{ textAlign: "center" }}>Confirm</div>}
        open={isModalVisible}
        onOk={handleOk}
        onCancel={handleCancel}
        centered
        style={{
          padding: "20px",
        }}
        width={300}
        footer={
          <div className="flex justify-center gap-3">
            <Button
              type="default"
              onClick={handleCancel}
              style={{ width: "30%" }}
            >
              Cancel
            </Button>
            <Button type="primary" onClick={handleOk} style={{ width: "30%" }}>
              Confirm
            </Button>
          </div>
        }
      >
        <p style={{ textAlign: "center" }}>
          Are you sure you want to booking date this record? Please note it will
          also delete all the details of this booking date.
        </p>
      </Modal>

      <Table
        columns={columns}
        scroll={{ x: "max-content" }}
        dataSource={booking}
        rowKey="id"
        style={{ marginTop: "10px" }}
        loading={loading}
        pagination={false}
        footer={() => (
          <div className="flex justify-between items-center text-xs ">
            <div className=" text-gray-600">
              Showing {(pagination.current - 1) * pagination.pageSize + 1} to{" "}
              {Math.min(pagination.current * pagination.pageSize, pagination.total)} of{" "}
              {pagination.total} entries
            </div>
            <Pagination
              current={pagination.current}
              total={pagination.total}
              pageSize={pagination.pageSize}
              showSizeChanger={false}
              onChange={(page) => initialize(page, pagination.pageSize)}
              itemRender={(current, type, originalElement) => {
                if (type === "prev") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Previous</a>;
                if (type === "next") return <a className="bg-[#EEEEEE] p-2 rounded-sm hover:text-primary">Next</a>;
                return originalElement;
              }}
            />
          </div>
        )}
      />
    </div>
  );
}

export default BookingSchedule;
